<template>
  <div class="audio-player">
    <audio
      v-if="tarUrl && tarUrl !== '--'"
      id="app-audio"
      :src="'http://' + tarUrl"
      @loadedmetadata="loadedmetadata"
      @ended="ended"
    ></audio>
  </div>
</template>

<script>
export default {
  name: 'AudioPlayer',
  props: {
    // 当前播放的音乐url + uuid
    audioUrl: {
      type: String,
      default: ''
    },
    // 当前播放的音乐url
    tarUrl: {
      type: String,
      default: ''
    }
  },
  watch: {
    audioUrl (newval, oldval) {
      newval = newval ? this._.split(newval, '?selfRandom=')[0] : ''
      oldval = oldval ? this._.split(oldval, '?selfRandom=')[0] : ''
      if (newval === oldval) {
        let audio = document.getElementById('app-audio')
        audio.pause()
        this.$emit('update:audioUrl', '')
      }
    }
  },
  methods: {
    loadedmetadata () {
      let audio = document.getElementById('app-audio')
      audio.play()
    },
    ended () {
      let audio = document.getElementById('app-audio')
      audio.pause()
      this.$emit('update:audioUrl', '')
      this.$emit('update:tarUrl', '')
    }
  }
}
</script>

<style lang="scss" scoped>
.audio-player {
  opacity: 0;
}
</style>
